const { NONE_DROPDOWN_VALUES } = require('@commons/constants/dropdown');

export const getFilteredStoresWithSelectedGroups = (selectedGroups, stores) => {
  const selectedGroupsIds = selectedGroups.map((group) => group.id);

  const hasSelectedNoneValue = selectedGroupsIds.includes(NONE_DROPDOWN_VALUES().MASCULINE.id);
  const onlyNoneValueSelected = selectedGroupsIds.length === 1 && hasSelectedNoneValue;

  const filteredStores = stores.filter((store) => {
    const storeGroups = store.groups.map((group) => group.id);
    if (onlyNoneValueSelected) {
      // Filter stores that do not have groups
      return !storeGroups.length;
    }

    const storeFilterCondition = storeGroups.some((groupId) => selectedGroupsIds.includes(groupId));

    if (hasSelectedNoneValue) {
      // Filter stores that do not have groups and add stores who matched selected groups
      return !storeGroups.length || storeFilterCondition;
    }

    return storeFilterCondition;
  });

  return filteredStores;
};
